
import React, { useCallback } from 'react';
import { Button } from 'reactstrap';
import './index.scss';
import Dropzone, { useDropzone } from "react-dropzone";
const UploadBlock = ({ name, avtar, handleFileUpload, detail }) => {


	const onDrop = useCallback(acceptedFiles => {
		handleFileUpload(acceptedFiles[0])
	}, [])


	/*
	 * hook used on browse file event
	 */
	const { open } = useDropzone({ onDrop });
	return (
		<>
			<div className="upload-blc d-flex align-items-center justify-content-center">
				<div className="inner text-center">
					<div className="pic">
						<img className='img-fluid' src={!avtar ? detail?.blob_name ? detail.blob_name : require('../../../../src/assets/img/icons/upload-img.svg') : avtar} height="50" width="50" alt='Upload Icon' />
					</div>
					{/*<UserPlaceholder /> */}
					<Dropzone
						onDrop={onDrop}
					>
						{({ getRootProps, getInputProps, isDragActive }) => (
							<div {...getRootProps()} className='lbl d-flex align-items-center justify-content-center'>
								<input {...getInputProps()} />
								{
									isDragActive ?
										<p>Drop the files here ...</p> :
										(<>

											<label>Drag image of {name} here or</label>
											<Button type="button" color="link" className="position-relative">
												Browse
												<input id="myInput" name="logo" type="file" className='position-absolute' onClick={open} />
												<input type="button" className='position-absolute' onclick="$('#myInput').click();" />
											</Button>

										</>
										)
								}
							</div>
						)}
					</Dropzone>


				</div>
				{/*userAvtar && (<div className="inner text-center">
				<div className="pic">
					<img className='img-fluid' src={userAvtar} alt='Upload Icon' height="100" width="100" />
				</div>
			
			</div>
	)*/}
			</div>

			{/* <div className='uploaded-media d-flex align-items-center'>
				<div className='pic rounded-circle'>
					<img className='img-fluid rounded-circle' src={require('../../../assets/img/user.png')} alt='User' />
					<UserPlaceholder />
				</div>
				<div className="info position-relative flex-fill">
					<label className='d-block'>John-Smith.png <span>7.5mb</span></label>
					<Progress value={75} />
					<Button color='link' className='position-absolute btn btn-link close-btn'>
						<FontAwesomeIcon icon={faTimes} />
					</Button>
				</div>
			</div> */}
		</>
	);
}

export default UploadBlock;